import { render } from "./CGoBack.vue?vue&type=template&id=f38fd864"
import script from "./CGoBack.vue?vue&type=script&lang=js"
export * from "./CGoBack.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__